export const environment = {
  production: true,
  baseUrl: 'https://asistenciastest.agd.com.ar/api-as',
  keyCrypto: 'EncriptaAGDappWeb',

  // reCAPTCHA Enterprise (GCP) - Staging
  reCaptchaEnterprise: {
    enabled: true,
    keyId: '6LePZfUsAAAAAHRtTFoeIK9bNo2uydTYGeQeajkI',
    projectId: 'agd-recaptcha',
    threshold: 0.3,
    apiUrl: 'https://www.google.com/recaptcha/enterprise.js',
    actions: {
      login: 'LOGIN',
      recoverPassword: 'RECOVER_PASSWORD',
      register: 'REGISTER',
      contact: 'CONTACT',
    },
  },

  // reCAPTCHA v2 (LEGACY - For rollback only)
  // captcha: {
  //   sitekey: '6LfkUb4mAAAAAIol9jlEas-krVoWTWgbURNuxbdg'
  // },
};
